module.exports = __webpack_public_path__ + "img/arrow_down.9b7a4535.svg";